export const STATEFUL_CONNECT_MODAL_ID = 'stateful-connect-modal';
export const PROFILE_WALLETS_MODAL_ID = 'profile-wallets-modal';
export const CONNECT_WALLETS_MODAL_ID = 'connect-wallets-modal';
